module.exports = __webpack_public_path__ + "img/call.5147887a.svg";